export enum RideTabsEnum {
  Basic = 0,
  Advanced = 1,
  Map = 2,
  Incidents = 3,
}
